@if (viewModel) {
	<app-document-section-expand-buttons [viewModel]="viewModel"></app-document-section-expand-buttons>
	<div class="scroll-vertical">
		@if (clinicalNote.manifest.nameChangeEnabled) {
			<div class="form-section">
				<div class="form-group" [formGroup]="nameForm!">
					<app-text-input class="validatable-control" [readOnly]="isReadOnly"
									[label]="clinicalNote.manifest.changeNameLabel || 'Name'"
									placeholder="Enter name" formControlName="name">
					</app-text-input>
				</div>
			</div>
		}
		@if (viewModel.sections.length === 1) {
			<app-document-section [section]="viewModel.sections[0]" [viewModel]="viewModel" [isReadOnly]="isReadOnly"></app-document-section>
			@if (clinicalNote.manifest.maximumAttachments) {
				<ng-container *ngTemplateOutlet="attachmentsContent; context: { showHeading: true }"></ng-container>
			}
		}
		@else {
			@for (section of viewModel.sections; track section.id; let index = $index) {
				<app-expander class="validatable-section" [formGroup]="viewModel.sectionGroups[section.id]">
					<app-item-label class="validation-section-label">{{section.metaData.title}}</app-item-label>
					<app-document-section [section]="section" [viewModel]="viewModel" [isReadOnly]="isReadOnly"></app-document-section>
				</app-expander>
			}
			@if (clinicalNote.manifest.maximumAttachments) {
				<app-expander>
					<app-item-label>{{ attachmentsLabel }}</app-item-label>
					<ng-container *ngTemplateOutlet="attachmentsContent; context: { clinicalNote, showHeading: false }"></ng-container>
				</app-expander>
			}
		}
	</div>
}
<ng-template #attachmentsContent let-showHeading="showHeading">
	<div class="form-section">
		<div class="form-group">
			@if (showHeading) {
				<app-heading background="secondary-2" size="small">{{ attachmentsLabel }}</app-heading>
			}
			@for (combinedClinicalNoteAttachment of combinedClinicalNoteAttachments; track combinedClinicalNoteAttachment.id) {
				<app-combined-attachment [combinedAttachment]="combinedClinicalNoteAttachment" [isReadOnly]="isReadOnly" @enter></app-combined-attachment>
			}
			@if (!isReadOnly && combinedClinicalNoteAttachments.length < clinicalNote.manifest.maximumAttachments!) {
				<app-attachment-upload [clinicalNoteId]="clinicalNote.id" @enter></app-attachment-upload>
			}
		</div>
	</div>
</ng-template>